import * as pdfjsLib from 'pdfjs-dist';
/* importa o worker como parte do próprio bundle (em vez de um arquivo separado
   buscado em runtime via import() dinâmico) — evita que proxy/antivírus/extensão
   que intercepte requisições de ".mjs"/"worker" quebre a abertura do PDF */
import 'pdfjs-dist/build/pdf.worker.min.mjs';

export { pdfjsLib };

/* renderiza cada página do PDF como miniatura (dataURL), tudo no navegador —
   o arquivo nunca sai da máquina do usuário */
export async function gerarMiniaturas(arrayBuffer, larguraAlvo = 140) {
  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
  const miniaturas = [];
  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i);
    const viewportBase = page.getViewport({ scale: 1 });
    const escala = larguraAlvo / viewportBase.width;
    const viewport = page.getViewport({ scale: escala });

    const canvas = document.createElement('canvas');
    canvas.width = viewport.width;
    canvas.height = viewport.height;
    await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise;

    miniaturas.push({ pagina: i, dataUrl: canvas.toDataURL('image/jpeg', 0.7) });
  }
  return miniaturas;
}
